import React from 'react';
import { adminAPI } from '../../../utils/api';
import EngagementView from './EngagementView';

const timeAgo = (iso) => {
  if (!iso) return 'unknown';
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(iso).toLocaleDateString();
};

const SimulationsTab = () => {
  const mapRunner = (row) => {
    const handle = row.sleeperUsername || row.metaUsername; // logged-in user, else username typed into the sim
    let title;
    if (row.email) title = row.email;
    else if (handle) title = `@${handle}`;
    else if (row.teamOwner) title = row.teamOwner;
    else title = `Anonymous · ${(row.visitorId || '').slice(0, 8)}`;
    const parts = [];
    if (row.teamName) parts.push(row.teamName);
    if (row.lastLeague) parts.push(row.lastLeague);
    parts.push(`last run ${timeAgo(row.lastRunAt)}`);
    return {
      id: row.visitorId,
      title,
      subtitle: parts.join(' · '),
      signedUp: !!row.signedUp,
      runs: row.runs,
    };
  };

  return (
    <EngagementView
      accent="#34C759"
      fetchStats={adminAPI.getSimulationStats}
      runWord="simulations"
      runnerWord="simulators"
      mapRunner={mapRunner}
    />
  );
};

export default SimulationsTab;
